import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import * as constants from 'constants'
import React from 'react'

import {
  ActivityDetails,
  ActivityGroupSelection,
  ActivityTypeSelection,
  PostTypeSelection,
} from 'pages/CreatePostModal'
import { ActionTypeSelection } from 'pages/CreatePostModal/ActionTypeSelection'

export type CreatePostStackParamList = {
  [constants.links.ACTION_TYPE_SELECTION_PAGE]: undefined
  [constants.links.POST_TYPE_SELECTION_PAGE]: undefined
  [constants.links.ACTIVITY_GROUP_SELECTION_PAGE]: undefined
  [constants.links.ACTIVITY_TYPE_SELECTION_PAGE]: undefined
  [constants.links.ACTIVITY_DETAILS_PAGE]: undefined
}

const Stack = createNativeStackNavigator<CreatePostStackParamList>()

export const CreatePostStack = ({
  drawerNavigationRef,
  ...rest
}: {
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}) => {
  const onAdd = rest?.data?.onAdd
  const programId = rest?.data?.programId

  return (
    <Stack.Navigator
      id='CreatePostStackNavigator'
      screenOptions={{
        headerShown: false,
        presentation: 'containedTransparentModal',
        animation: 'none',
      }}
    >
      {(programId || onAdd) && (
        <Stack.Screen name={constants.links.ACTION_TYPE_SELECTION_PAGE}>
          {(props) => (
            <ActionTypeSelection
              onAdd={onAdd}
              programId={programId}
              drawerNavigationRef={drawerNavigationRef}
              {...props}
            />
          )}
        </Stack.Screen>
      )}

      <Stack.Screen name={constants.links.POST_TYPE_SELECTION_PAGE}>
        {(props) => <PostTypeSelection drawerNavigationRef={drawerNavigationRef} {...props} />}
      </Stack.Screen>

      <Stack.Screen
        name={constants.links.ACTIVITY_GROUP_SELECTION_PAGE}
        component={ActivityGroupSelection}
        options={{ title: 'Activity Group' }}
      />

      <Stack.Screen
        name={constants.links.ACTIVITY_TYPE_SELECTION_PAGE}
        options={{ title: 'Activity Type' }}
        component={ActivityTypeSelection}
      />

      <Stack.Screen
        name={constants.links.ACTIVITY_DETAILS_PAGE}
        options={{ title: 'Activity Details' }}
      >
        {(props) => <ActivityDetails drawerNavigationRef={drawerNavigationRef} {...props} />}
      </Stack.Screen>
    </Stack.Navigator>
  )
}
